import { render } from "./topcollaction.vue?vue&type=template&id=4aa2db89"
import script from "./topcollaction.vue?vue&type=script&lang=js"
export * from "./topcollaction.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__